import setMinutes from 'utils/time/setMinutes';
import setHours from 'utils/time/setHours';

export function setHoursAndMinutes(dateToModify: Date, date: Date): Date {
  const hours = date.getHours();
  const minutes = date.getMinutes();
  return setMinutes(setHours(dateToModify, hours), minutes);
}
